import { Toaster } from "sonner";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Installment from "./pages/Installment";
import History from "./pages/History";
import Profile from "./pages/Profile";
import Notification from "./pages/Notification";
import WatchBus from "./pages/WatchBus";
import Login from "./pages/Login";
import SmsVerification from "./pages/SmsVerification"; 
import Checkout from "./pages/Checkout";
import PaymentWebViewScreen from "./pages/PaymentWebViewScreen";
import PrivacyPolicy from "./pages/Policies/PrivacyPolicy";
import KvkkPolicy from "./pages/Policies/KvkkPolicy";
import CookiePolicy from "./pages/Policies/CookiePolicy";
import ServiceAgreement from "./pages/Policies/ServiceAgreement";
import CancellationAndRefund from "./pages/Policies/CancellationAndRefund";
import ScrollToTop from "./components/ScrollToTop";

import { DataProvider } from "./data/DataProvider";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function MainLayout() {
  return (
    <div className="bg-gray-50 flex flex-col min-h-screen">
      <Header isLoginPage={false} />
      <main className="grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

function PublicLayout() {
  return (
    <div className="bg-gray-50 flex flex-col min-h-screen">
      <Header isLoginPage={true} />
      <main className="grow">
        <Outlet />
      </main>
    </div>
  );
}

export default function App() {
  return (
    <>
      <Toaster position="top-right" richColors />

      <DataProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/login" element={<Login />} />
              <Route
                path="/sms-verification"
                element={<SmsVerification />}
              />{" "}
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/kvkk" element={<KvkkPolicy />} />
              <Route path="/cookies" element={<CookiePolicy />} />
              <Route path="/service-agreement" element={<ServiceAgreement />} />
              <Route
                path="/cancellation-and-refund"
                element={<CancellationAndRefund />}
              />
            </Route>

            <Route element={<MainLayout />}>
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/installment"
                element={
                  <ProtectedRoute>
                    <Installment />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/checkout"
                element={
                  <ProtectedRoute>
                    <Checkout />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/payment-webview"
                element={
                  <ProtectedRoute>
                    <PaymentWebViewScreen />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/payment-webview-screen"
                element={
                  <ProtectedRoute>
                    <PaymentWebViewScreen />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/history"
                element={
                  <ProtectedRoute>
                    <History />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/notification"
                element={
                  <ProtectedRoute>
                    <Notification />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/watch-bus"
                element={
                  <ProtectedRoute>
                    <WatchBus />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </DataProvider>
    </>
  );
}
